import { sortOptionKeys, SortOptionKey, SortSettings } from './config'

/**
 * How the `sort` settings resolve to the ONE sort the widget actually applies.
 *
 * Deliberately not in config.ts: that file is the schema declaration, and the
 * dead-setting sentinel excludes it from usage analysis by design, so a leaf
 * read only there would be reported as dead (`sort.options` was, once).
 * Both readers below — the browse query funnel (`data.ts`) and the dropdown
 * (`components/filters/SortDropdown.tsx`) — come through here, so the value
 * the visitor sees preselected and the value the request carries can't drift.
 */

/**
 * The sort options offered to visitors, curated and ordered by the admin
 * (WP: orderby_options). Empty/undefined = every option in the schema order.
 * Unknown keys are dropped rather than passed through — a stored list can
 * predate a retired key.
 */
export function resolveSortOptions(sort: SortSettings): SortOptionKey[] {
  const curated = sort.options?.filter((v): v is SortOptionKey =>
    (sortOptionKeys as readonly string[]).includes(v),
  )
  return curated?.length ? curated : [...sortOptionKeys]
}

/**
 * THE sort applied when the visitor has not chosen one — the dropdown's
 * preselected value AND the `sort_by` every initial query carries (#1093;
 * before that this resolution existed only in SortDropdown and never reached
 * the request). Falls back to the first offered option when the admin narrowed
 * the list after picking a default (#557). Total: never returns undefined, so
 * the SSR key and the client key can't diverge on an empty list.
 */
export function resolveDefaultSort(sort: SortSettings): SortOptionKey {
  const offered = resolveSortOptions(sort)
  return offered.includes(sort.default) ? sort.default : (offered[0] ?? sort.default)
}
